import React from 'react';
import { ArrowRightIcon, CircleCheckIcon } from 'lucide-react';
import { CHECKOUT_URL, DEFAULT_CTA_SUB } from '../data/content';
type CtaButtonProps = {
  label: string;
  sub?: string | null;
  id?: string;
  tone?: 'light' | 'dark';
};
export function CtaButton({
  label,
  sub = DEFAULT_CTA_SUB,
  id,
  tone = 'light'
}: CtaButtonProps) {
  return <div className="flex w-full flex-col items-center text-center" data-id="element-99" data-mp="cmvm9mqa65v2">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-4 text-[15px] font-extrabold uppercase leading-snug tracking-wide text-white shadow-[0_12px_28px_-10px_rgba(22,163,74,0.75)] ring-1 ring-inset ring-white/20 transition-[transform,background-color] duration-150 ease-out hover:bg-ctaDark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:py-5 sm:text-lg" data-id="element-100" data-mp="qj944wyq89a2">
        <CircleCheckIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-101" data-mp="15b1709hc3uuw" />
        <span className="text-balance" data-id="element-102" data-mp="35xxp4gty87oj">{label}</span>
        <ArrowRightIcon className="hidden h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" aria-hidden="true" data-id="element-103" data-mp="35zimee7ne4q3" />
      </a>
      {sub && <p className={`mt-3 max-w-xl text-sm leading-relaxed ${tone === 'dark' ? 'text-white/70' : 'text-muted'}`} data-id="element-104" data-mp="3jwxh9ygo74pg">{sub}</p>}
    </div>;
}